import { Link, useLocation } from 'react-router-dom';
import { ROUTE_PATHS } from '../../app/router/route-paths';
import { useAuth } from '../../shared/auth/use-auth';
import { cn } from '../../shared/lib/cn';
import { userFacingLoadError } from '../../shared/lib/staff-user-facing-error';
import { getButtonClassNames } from '../../shared/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shared/ui/Card';
import { Stack } from '../../shared/ui/Stack';

export default function BootstrapErrorPage() {
  const { fetchError } = useAuth();
  const location = useLocation();
  const raw = ((location.state as { message?: string } | null)?.message ?? fetchError ?? '').trim();
  const summary = raw ? userFacingLoadError(new Error(raw)) : 'Не удалось загрузить данные.';

  return (
    <div className="staff-system-shell">
      <Card className="staff-system-inner">
        <CardHeader>
          <CardTitle>Ошибка загрузки</CardTitle>
          <CardDescription>
            Проверьте сеть и доступность сервиса. Если проблема повторяется, обратитесь к администратору.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Stack gap={4}>
            <p className="staff-m-0 text-sm text-[hsl(var(--ui-muted-foreground))]">{summary}</p>
            <Link
              to={ROUTE_PATHS.login}
              className={cn(getButtonClassNames({ variant: 'secondary' }), 'staff-link-button')}
            >
              К входу
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
}
